import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from './reportsMessages';

import './CardsLegend.scss';

export const colors = [
  {
    color: '#0DD396',
    label: 'hit',
  },
  {
    color: '#FF836A',
    label: 'error',
  },
  {
    color: '#FFAF2E',
    label: 'didNotAnswer',
  },
  {
    color: '#555555',
    label: 'canceled',
  },
];

const CardsLegend = props => (
  <div className="CardsLegend">
    <strong>Legenda:</strong>
    <div className="squares mt-2">
      {colors.map(item => (
        <div className="square-block">
          <div className="square" style={{ backgroundColor: item.color }} />
          <label>
            <FormattedMessage {...messages[`${item.label}`]} />
          </label>
        </div>
      ))}
    </div>
  </div>
);

CardsLegend.propTypes = {};

export default CardsLegend;
